import React, { Suspense, PureComponent, lazy } from 'react';
import { Button, Icon, Tooltip } from '@fiverr-private/fit';
import { s_flag } from '@fiverr-private/fit/icons';
import { bool, object } from 'prop-types';
import { BQ_CLICKED_REPORT_GIG } from '../../../../utils/bigQueryEvents';

import './style.scss';

const ReportGig = lazy(() => import(/* webpackChunkName: 'ReportGig' */'..'));

class ReportBtn extends PureComponent {

    constructor() {
        super();

        // we need this to delay the render of the ReportGig component on the server side (SSR doesn't support
        // lazy loading), so we have to use this hack
        // we will set this flag to true on componentDidMount
        this.state = {
            renderReportGig: false
        };

        this.setOpenModalHandle = this.setOpenModalHandle.bind(this);
        this.onReportBtnClick = this.onReportBtnClick.bind(this);
    }

    componentDidMount() {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
            renderReportGig: true
        });
    }

    onReportBtnClick() {

        const { biEvents } = this.context;
        biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_REPORT_GIG });

        this.openModal();
    }

    setOpenModalHandle(open) {
        this.openModal = open;
    }

    render() {
        const { isTrustedUser, tooltipText } = this.props;
        const { renderReportGig } = this.state;

        return (
            <>
                <Tooltip className="report-gig-tooltip"
                    containerClassName="report-gig-tooltip-container"
                    boxContentClassName="report-gig-tooltip-box"
                    content={tooltipText}>
                    <Button className="btn-report-gig" onClick={this.onReportBtnClick}>
                        <Icon className="report-gig-icon">{s_flag}</Icon>
                    </Button>
                </Tooltip>

                { renderReportGig &&
                    <Suspense fallback={<div/>}>
                        <ReportGig trigger={this.setOpenModalHandle} isTrustedUser={isTrustedUser}/>
                    </Suspense>
                }
            </>
        );
    }
}

ReportBtn.propTypes = {
    isTrustedUser: bool
};

ReportBtn.defaultProps = {
    isTrustedUser: false
};

ReportBtn.contextTypes = {
    biEvents: object
};

export default ReportBtn;
